import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Users, Menu, X, ChevronRight } from "lucide-react";
import { useState, useEffect } from "react";
import soleToSoleLogo from "@/assets/sole-to-sole-logo.png";

const promoMessages = [
  "MARKET HALL VENDOR APPLICATIONS OPEN",
  "JUNE 20 AT DALLAS MARKET HALL",
  "APPLY TO JOIN THE NEXT SOLE TO SOLE EVENT",
];

const Navbar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [currentPromo, setCurrentPromo] = useState(0);
  const isActive = (path: string) => location.pathname === path;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPromo((prev) => (prev + 1) % promoMessages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      {/* Promo Banner */}
      <Link
        to="/apply?event=0f905764-6175-44bb-ab5c-b8c8840bd42b"
        className="block overflow-hidden border-b border-background/10 bg-foreground px-3 py-2 text-center text-background transition-opacity hover:opacity-95 sm:px-4"
      >
        <span className="inline-flex max-w-full items-center gap-1.5 whitespace-nowrap text-[11px] font-black uppercase tracking-[0.08em] sm:text-sm">
          <span className="animate-fade-in overflow-hidden text-ellipsis">
            {promoMessages[currentPromo]}
          </span>
          <ChevronRight className="h-4 w-4 shrink-0 stroke-[2.75]" />
        </span>
      </Link>

      {/* Main Nav */}
      <nav className="bg-white border-b border-border">
        <div className="container mx-auto px-4">
          <div className="relative flex items-center justify-between h-16">
            <div className="hidden md:flex items-center gap-6">
              <Link to="/" className={`text-sm font-medium transition-colors hover:text-primary ${isActive('/') ? 'text-primary' : 'text-muted-foreground'}`}>
                Home
              </Link>
              <Link to="/events" className={`text-sm font-medium transition-colors hover:text-primary ${isActive('/events') ? 'text-primary' : 'text-muted-foreground'}`}>
                Events
              </Link>
              <Link to="/about" className={`text-sm font-medium transition-colors hover:text-primary ${isActive('/about') ? 'text-primary' : 'text-muted-foreground'}`}>
                About
              </Link>
            </div>

            <div className="hidden md:flex items-center">
              <Link to="/apply">
                <Button size="sm" className="gap-2">
                  <Users className="w-4 h-4" />
                  Become a Vendor
                </Button>
              </Link>
            </div>

            <Link to="/" className="absolute left-1/2 flex -translate-x-1/2 items-center justify-center gap-2">
              <img src={soleToSoleLogo} alt="Sole to Sole Logo" width={40} height={40} className="w-10 h-10 rounded-lg object-contain" />
              <span className="font-heading font-semibold text-foreground hidden sm:inline text-sm tracking-wide">SOLE TO SOLE</span>
            </Link>

            <div className="md:hidden">
              <Link to="/apply">
                <Button size="sm" className="h-8 gap-1 px-2 text-[10px] font-semibold sm:h-9 sm:px-3 sm:text-xs">
                  <Users className="h-3.5 w-3.5" />
                  <span className="leading-none">Vendors Apply</span>
                </Button>
              </Link>
            </div>

            <button className="md:hidden p-2 ml-auto" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu">
              {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {isOpen &&
          <div className="md:hidden py-4 border-t border-border">
              <div className="flex flex-col gap-4">
                <Link to="/" className={`text-sm font-medium transition-colors hover:text-primary ${isActive('/') ? 'text-primary' : 'text-muted-foreground'}`} onClick={() => setIsOpen(false)}>
                  Home
                </Link>
                <Link to="/events" className={`text-sm font-medium transition-colors hover:text-primary ${isActive('/events') ? 'text-primary' : 'text-muted-foreground'}`} onClick={() => setIsOpen(false)}>
                  Events
                </Link>
                <Link to="/about" className={`text-sm font-medium transition-colors hover:text-primary ${isActive('/about') ? 'text-primary' : 'text-muted-foreground'}`} onClick={() => setIsOpen(false)}>
                  About
                </Link>
                <Link to="/apply" onClick={() => setIsOpen(false)}>
                  <Button size="sm" className="w-full gap-2">
                    <Users className="w-4 h-4" />
                    Become a Vendor
                  </Button>
                </Link>
              </div>
            </div>
          }
        </div>
      </nav>
    </div>);

};
export default Navbar;